import { render, staticRenderFns } from "./MedicationDetails.vue?vue&type=template&id=cd040220&"
import script from "./MedicationDetails.vue?vue&type=script&lang=js&"
export * from "./MedicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./MedicationDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports